<template>
  <div>
    <div
      style="z-index:5; position:absolute; bottom:10px; left:10px; width:100px; filter: drop-shadow(2px 4px 6px black);"
      class="blink"
    >
      <v-btn depressed color="error" @click="maximized = true"
        >Clique aqui para voltar</v-btn
      >
    </div>

    <v-dialog
      v-model="maximized"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Rodada Virtual</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="red" @click="sairSalaVirtual">
            Sair da sala
          </v-btn>
          <v-btn color="primary lighten-4 ml-4" @click="maximized = false">
            Minimizar
          </v-btn>
        </v-toolbar>

        <div
          style="display:flex; padding: 10px; overflow: hidden; position: relative; height: calc(100vh - 70px)"
        >
          <v-btn
            v-if="zoomIn"
            class="mx-2"
            fab
            dark
            small
            color="warning"
            style="position: absolute; top: 20px; right: 10px; z-index:101"
            @click="
              (event) => {
                event.stopPropagation();
                onZoomOut();
              }
            "
          >
            <v-icon dark>
              mdi-close
            </v-icon>
          </v-btn>

          <div style="width: 40%; display: flex; flex-wrap: wrap; gap: 10px;">
            <div style="width: 100%; position: relative; line-height: normal;">
              <video
                :id="(user.tipo === 'cliente' ? 'for' : 'cli') + '-video'"
                autoplay="autoplay"
                poster="https://images.wallpaperscraft.com/image/man_profile_silhouette_circle_118321_320x240.jpg"
                style="width:100%; border-radius:4px;"
                muted
              />

              <v-icon
                v-if="!zoomIn"
                style="position: absolute; margin: 10px; left: 0px; filter: drop-shadow(0px 0px 2px black);"
                dark
                large
                @click="
                  (event) => {
                    event.stopPropagation();
                    onZoomIn(
                      (user.tipo === 'cliente' ? 'for' : 'cli') + '-video'
                    );
                  }
                "
              >
                mdi-fullscreen
              </v-icon>

              <div
                style="position: absolute; margin: 10px; bottom: 0px; left: 0px; filter: drop-shadow(0px 0px 2px black); color: white; font-weight: 500;width: 90%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;"
              >
                {{ clienteFornecedorNome }}
              </div>
            </div>

            <div style="width: calc(50% - 5px); position: relative;">
              <video
                :id="(user.tipo === 'cliente' ? 'cli' : 'for') + '-video'"
                autoplay="autoplay"
                poster="https://images.wallpaperscraft.com/image/man_profile_silhouette_circle_118321_320x240.jpg"
                style="border-radius:4px; width: 100%"
                muted
              />

              <v-icon
                v-if="!zoomIn"
                style="position: absolute; margin: 10px; left: 0px; filter: drop-shadow(0px 0px 2px black);"
                dark
                large
                @click="
                  (event) => {
                    event.stopPropagation();
                    onZoomIn(
                      (user.tipo === 'cliente' ? 'cli' : 'for') + '-video'
                    );
                  }
                "
              >
                mdi-fullscreen
              </v-icon>

              <div
                style="position: absolute; margin: 10px; bottom: 0px; left: 0px; filter: drop-shadow(0px 0px 2px black); color: white; font-weight: 500;width: 90%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;"
              >
                {{ meuNome }}
              </div>
            </div>

            <div style="width: calc(50% - 5px); position: relative;">
              <video
                id="rep-video"
                autoplay="autoplay"
                poster="https://images.wallpaperscraft.com/image/man_profile_silhouette_circle_118321_320x240.jpg"
                style="border-radius:4px; width: 100%"
                muted
              />

              <v-icon
                v-if="!zoomIn"
                style="position: absolute; margin: 10px; left: 0px; filter: drop-shadow(0px 0px 2px black);"
                dark
                large
                @click="
                  (event) => {
                    event.stopPropagation();
                    onZoomIn('rep-video');
                  }
                "
              >
                mdi-fullscreen
              </v-icon>

              <div
                style="position: absolute; margin: 10px; bottom: 0px; left: 0px; filter: drop-shadow(0px 0px 2px black); color: white; font-weight: 500;width: 90%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;"
              >
                {{ representanteNome }}
              </div>
            </div>

            <div style="width: 100%; height: -webkit-fill-available;">
              <v-btn depressed color="primary" @click="mute"
                >Mudo / Falar</v-btn
              >

              <v-btn depressed color="primary" @click="enviarMensagem"
                >Send</v-btn
              >
            </div>
          </div>

          <div style="width: 60%; padding-left: 10px">
            <v-card>
              <v-app-bar color="primary" flat dark dense>
                <v-toolbar-title>Pedido</v-toolbar-title>
              </v-app-bar>

              <v-row dense class="pb-3 pt-3 px-5">
                <v-progress-linear
                  buffer-value="100"
                  color="success"
                  value="60"
                />
              </v-row>
            </v-card>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const constraints = {
  audio: true,
  video: {
    width: { max: 320 },
    height: { max: 240 },
    frameRate: { max: 30 },
  },
};

let serverConnection;
let localStream;
let peerConnections = {};

let id;
let roomId;
let localUuid;
let localDisplayName;

const peerConnectionConfig = {
  iceServers: [
    { url: "stun:stun3.l.google.com:19302" },
    { url: "stun:anronsoftware.com.br:3478" },
    {
      url: "turn:anronsoftware.com.br:3478",
      credential: "87ef5318d563eec4",
      username: "anronsoftware",
    },
  ],
};

export default {
  name: "RodadaVirtual",
  data() {
    return {
      active: false,
      maximized: true,
      notifications: false,
      sound: true,
      widgets: false,

      XroomId: "anron",
      Xid: "cli",
      idVideo: "",
      zoomIn: false,
      user: {},
      clienteFornecedorNome: "",
      representanteNome: "Representante",
      meuNome: "",
    };
  },

  mounted() {
    this.user = JSON.parse(localStorage.getItem("user") || "{}");
    this.clienteFornecedorNome =
      this.user.tipo === "cliente" ? "Fornecedor" : "Cliente";
    this.Xid = this.user.tipo.substring(0, 3);
    this.XroomId = this.$store.state.rodadaVirtualData.data.uuid;

    id = this.Xid;
    roomId = this.XroomId;
    localDisplayName = id + "-" + roomId;

    localUuid = this.createUUID();

    switch (this.user.tipo) {
      case "cliente":
        this.meuNome = this.$store.state.rodadaVirtualData.data.clienteNome;
        this.clienteFornecedorNome = this.$store.state.rodadaVirtualData.data.fornecedorNome;
        this.representanteNome = this.$store.state.rodadaVirtualData.data.representanteNome;
        break;
      case "fornecedor":
        this.meuNome = this.$store.state.rodadaVirtualData.data.fornecedorNome;
        this.clienteFornecedorNome = this.$store.state.rodadaVirtualData.data.clienteNome;
        this.representanteNome = this.$store.state.rodadaVirtualData.data.representanteNome;
        break;
      case "representante":
        this.clienteFornecedorNome = this.$store.state.rodadaVirtualData.data.clienteNome;
        this.meuNome = this.$store.state.rodadaVirtualData.data.fornecedorNome;
        this.representanteNome = this.$store.state.rodadaVirtualData.data.representanteNome;
        break;

      default:
        break;
    }

    this.init();
  },

  methods: {
    sairSalaVirtual() {
      this.mute();
      setTimeout(() => {
        serverConnection.close();
        localStream.getTracks().forEach((t) => t.stop());
        Object.keys(peerConnections).map((key) => {
          peerConnections[key].pc.close();
        });
        peerConnections = {};

        this.$store.commit("setRodadaVirtual", { status: false, data: {} });
      }, 500);
    },

    mute() {
      const vidElement = document.getElementById(id + "-video");
      vidElement.srcObject.getVideoTracks()[0].enabled = !vidElement.srcObject.getVideoTracks()[0]
        .enabled;
    },

    onZoomIn(elementId) {
      this.idVideo = elementId;
      this.zoomIn = true;
      const vidElement = document.getElementById(elementId);

      vidElement.style.zIndex = "100";
      vidElement.style.width = "calc(100vw - 20px)";
      vidElement.style.position = "absolute";
      vidElement.style.top = "10px";
      vidElement.style.bottom = "10px";
      vidElement.style.left = "10px";
      vidElement.parentElement.style.position = "static";
      vidElement.parentElement.children[2].style.bottom = "auto";
      vidElement.parentElement.children[2].style.top = "10px";
      vidElement.parentElement.children[2].style.left = "10px";
      vidElement.parentElement.children[2].style.zIndex = "102";
    },

    onZoomOut() {
      this.zoomIn = false;
      const vidElement = document.getElementById(this.idVideo);
      vidElement.style.zIndex = "auto";
      vidElement.style.width = "100%";
      vidElement.style.position = "relative";
      vidElement.style.top = "auto";
      vidElement.style.bottom = "auto";
      vidElement.style.left = "auto";
      vidElement.parentElement.style.position = "relative";
      vidElement.parentElement.children[1].style.bottom = "0px";
      vidElement.parentElement.children[1].style.top = "auto";
      vidElement.parentElement.children[1].style.left = "0px";
      vidElement.parentElement.children[1].style.zIndex = "auto";
    },

    init() {
      if (navigator.mediaDevices.getUserMedia) {
        const self = this;
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(function(stream) {
            localStream = stream;
            const vidElement = document.getElementById(id + "-video");
            vidElement.srcObject = stream;
            vidElement.visibility = "visible";
          })
          .catch(this.errorHandler)
          .then(function() {
            serverConnection = new WebSocket(
              process.env.NODE_ENV === "production"
                ? "wss://websocket.anronsoftware.com.br"
                : process.env.VUE_APP_BASE_WEBSOCKET_API
            );
            serverConnection.onmessage = self.gotMessageFromServer;
            serverConnection.onopen = function() {
              serverConnection.send(
                JSON.stringify({
                  displayName: localDisplayName,
                  uuid: localUuid,
                  roomId,
                  dest: roomId,
                })
              );
            };
          })
          .catch(self.errorHandler);
      } else {
        alert("Seu navegador não é compativel!");
      }
    },

    enviarMensagem() {
      serverConnection.send(
        JSON.stringify({
          uuid: localUuid,
          dest: roomId,
          mensagem: "Works!",
        })
      );
    },

    gotMessageFromServer(message) {
      const signal = JSON.parse(message.data);
      const peerUuid = signal.uuid;

      if (
        peerUuid === localUuid ||
        (signal.dest !== localUuid && signal.dest !== roomId)
      ) {
        return;
      }

      if (signal.displayName && signal.dest === roomId) {
        this.setUpPeer(peerUuid, signal.displayName);
        serverConnection.send(
          JSON.stringify({
            displayName: localDisplayName,
            uuid: localUuid,
            dest: peerUuid,
            roomId,
          })
        );
      } else if (signal.displayName && signal.dest === localUuid) {
        this.setUpPeer(peerUuid, signal.displayName, true);
      } else if (signal.sdp) {
        const self = this;
        peerConnections[peerUuid].pc
          .setRemoteDescription(new RTCSessionDescription(signal.sdp))
          .then(function() {
            if (signal.sdp.type == "offer") {
              peerConnections[peerUuid].pc
                .createAnswer()
                .then(function(description) {
                  self.createdDescription(description, peerUuid);
                })
                .catch(self.errorHandler);
            }
          })
          .catch(self.errorHandler);
      } else if (signal.ice) {
        const self = this;
        peerConnections[peerUuid].pc
          .addIceCandidate(new RTCIceCandidate(signal.ice))
          .catch(self.errorHandler);
      } else if (signal.uuid !== localUuid) {
        // Exibir pedido aqui
        console.log(signal);
      }
    },

    setUpPeer(peerUuid, displayName, initCall = false) {
      Object.keys(peerConnections).map((key) => {
        if (key.substring(0, 3) === peerUuid.substring(0, 3)) {
          peerConnections[key].pc.close();
          delete peerConnections[key];
        }
      });

      const self = this;
      peerConnections[peerUuid] = {
        displayName: displayName,
        pc: new RTCPeerConnection(peerConnectionConfig),
      };
      peerConnections[peerUuid].pc.onicecandidate = function(event) {
        self.gotIceCandidate(event, peerUuid);
      };
      peerConnections[peerUuid].pc.ontrack = function(event) {
        self.gotRemoteStream(event, peerUuid);
      };
      peerConnections[peerUuid].pc.oniceconnectionstatechange = function(
        event
      ) {
        self.checkPeerDisconnect(event, peerUuid);
      };
      peerConnections[peerUuid].pc.addStream(localStream);

      if (initCall) {
        const self = this;
        peerConnections[peerUuid].pc
          .createOffer({ iceRestart: true })
          .then(function(description) {
            self.createdDescription(description, peerUuid);
          })
          .catch(self.errorHandler);
      }
    },

    gotIceCandidate(event, peerUuid) {
      if (event.candidate != null) {
        serverConnection.send(
          JSON.stringify({
            ice: event.candidate,
            uuid: localUuid,
            dest: peerUuid,
            roomId,
          })
        );
      }
    },

    createdDescription(description, peerUuid) {
      const self = this;
      peerConnections[peerUuid].pc
        .setLocalDescription(description)
        .then(function() {
          serverConnection.send(
            JSON.stringify({
              sdp: peerConnections[peerUuid].pc.localDescription,
              uuid: localUuid,
              dest: peerUuid,
              roomId,
            })
          );
        })
        .catch(self.errorHandler);
    },

    gotRemoteStream(event, peerUuid) {
      const vidElement = document.getElementById(
        peerUuid.substring(0, 3) + "-video"
      );
      if (vidElement) {
        vidElement.dataset.peerUuid = peerUuid;
        vidElement.muted = false;
        vidElement.visibility = "visible";
        vidElement.srcObject = event.streams[0];
      }
    },

    checkPeerDisconnect(event, peerUuid) {
      const state = peerConnections[peerUuid]?.pc.iceConnectionState || null;
      if (
        state === "failed" ||
        state === "closed" ||
        state === "disconnected"
      ) {
        delete peerConnections[peerUuid];
        const vidElement = document.getElementById(
          peerUuid.substring(0, 3) + "-video"
        );
        if (vidElement && vidElement.dataset.peerUuid === peerUuid) {
          vidElement.visibility = "hidden";
          vidElement.srcObject = null;
          vidElement.load();
        }
      }
    },

    errorHandler(error) {
      console.error(error);
    },

    createUUID() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }

      return (
        id +
        "-" +
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
      );
    },
  },
};
</script>

<style @scoped>
.blink {
  animation: unset;
}
</style>
